module.exports = __webpack_public_path__ + "static/media/discount-icon.21c2fff6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upgradeReason/discount-icon.svg
// module id = 1516
// module chunks = 0